module.exports = {"pageTitleText":"資源用量總覽","resourceUsageLineChart":"資源用量折線圖"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/subscription.json
// module id = toaX
// module chunks = 3